// ============================================================================
// diagnostika.js — rövid HIBAKÓDOK és másolható HIBAKERESŐ ADATOK a bejelentkezéshez és a jogosultság-ellenőrzéshez (2026-10-19, a titkár #46
// kérése: "Újrapróbálás és egy rövid hibaszám; az eredeti szoba és téma megőrzése; korlátos újrapróbálás; a diagnosztika nem tartalmazhat jelszót vagy
// tokent"). Tiszta függvények: Node-ban tesztelhetők.
//
// A kód alakja: <betű><szám>[:<firebase-hibakód>], pl. "L2:auth/popup-blocked". A betű a szakaszt jelöli (L = belépés, A = jogosultság-ellenőrzés).
// A részlet csak biztonságos karaktereket tartalmazhat (betű, szám, / _ . -), ezért e-mail-cím, azonosító vagy token nem kerülhet bele.
//
// A másolható adatok SOSEM tartalmaznak: jelszót, tokent, kulcsot, e-mail-címet, felhasználó-azonosítót, az oldal útvonalát vagy hash-ét (szoba / téma).
// ============================================================================

export const KODOK = {
  LOGIN_STUCK: "L1", // 30 mp után sincs bejelentkezett felhasználó (üres maradt a felugró ablak / nem tért vissza az eredmény)
  LOGIN_FAILED: "L2", // a bejelentkezés indítása hibát dobott
  LOGIN_REDIRECT_SILENT: "L3", // az átirányításos bejelentkezés némán elbukott (visszatérés felhasználó nélkül)
  LOGIN_REDIRECT_ERROR: "L4", // a visszatérési eredmény feldolgozása hibát dobott
  LOGIN_NO_EMAIL: "L5", // a Google-fiókhoz nincs e-mail-cím
  LOGIN_NOT_VERIFIED: "L6", // az e-mail-cím nincs megerősítve
  ACCESS_SLOW: "A1", // a jogosultság-ellenőrzés 8 mp után sem fejeződött be
  ACCESS_TIMEOUT: "A2", // a jogosultság-ellenőrzés 40 mp után időtúllépéssel leállt
  ACCESS_ERROR: "A3", // a jogosultság-ellenőrzés hibával leállt
};

/** Ennyi egymás utáni kézi újrapróbálás után a lap a hibakereső adatok küldését kéri (és nem biztat tovább ugyanazzal). */
export const UJRAPROBA_HATAR = 3;

/** A részlet biztonságos alakja: csak betű, szám és / _ . - ; legfeljebb 40 karakter (egy Firebase-hibakód ilyen). */
export function biztonsagosReszlet(reszlet) {
  const s = String(reszlet == null ? "" : reszlet).replace(/[^A-Za-z0-9/_.-]/g, "");
  return s.slice(0, 40);
}

/** A hibakód szövege: "L2" vagy "L2:auth/popup-blocked". */
export function hibaKod(kod, reszlet) {
  const r = biztonsagosReszlet(reszlet);
  return r ? `${kod}:${r}` : String(kod);
}

/** A böngésző és az operációs rendszer RÖVID neve a User-Agentből (nincs verziószám, nincs egyedi azonosító). */
export function bongeszoRovid(ua) {
  const s = String(ua || "");
  const bongeszo = /Edg\//.test(s) ? "Edge" : /OPR\//.test(s) ? "Opera" : /Firefox\//.test(s) ? "Firefox" : /Chrome\/|CriOS\//.test(s) ? "Chrome" : /Safari\//.test(s) ? "Safari" : "ismeretlen";
  const rendszer = /iPhone|iPad|iPod/.test(s) ? "iOS" : /Android/.test(s) ? "Android" : /Windows/.test(s) ? "Windows" : /Mac OS X|Macintosh/.test(s) ? "macOS" : /Linux/.test(s) ? "Linux" : "ismeretlen";
  return `${bongeszo} / ${rendszer}`;
}

/**
 * A másolható hibakereső adatok (egyszerű szöveg).
 * @param {object} a { kod, host, env, kiadas, verzio, ut ("popup"|"redirect"), telepitett, ua, online, nyelv, ido }
 */
export function diagnosztikaSzoveg(a) {
  const x = a || {};
  const ido = x.ido instanceof Date ? x.ido : new Date();
  const sorok = [
    "Lineage0 hibakereső adatok",
    `Hibakód: ${x.kod || "-"}`,
    `Időpont: ${ido.toISOString()}`,
    `Cím: ${biztonsagosHost(x.host)}`,
    `Üzemmód: ${x.env || "-"}`,
    `Kiadás / build: ${x.kiadas || "-"} / ${x.verzio || "-"}`,
    `Bejelentkezési út: ${x.ut || "-"}`,
    `Telepített alkalmazás: ${x.telepitett ? "igen" : "nem"}`,
    `Böngésző: ${bongeszoRovid(x.ua)}`,
    `Online: ${x.online === false ? "nem" : "igen"}`,
    `Felületi nyelv: ${biztonsagosReszlet(x.nyelv) || "-"}`,
  ];
  return sorok.join("\n");
}

/** Csak a tartománynév (nincs útvonal, hash, lekérdezés, port-azonosító): "lineage0.com". */
export function biztonsagosHost(host) {
  const s = String(host || "").toLowerCase();
  return /^[a-z0-9]([a-z0-9.-]*[a-z0-9])?$/.test(s) ? s : "-";
}
